// Configurazione statica del sito (nessun backend necessario).
// Per cambiare link, logo o testi in futuro, modifica questi valori e ripubblica.
export const SITE = {
  googleUrl: "https://g.page/r/CRvqLSLtMh52EAE/review",
  tripadvisorUrl: "https://www.tripadvisor.it/UserReviewEdit-d24156082?m=68676",
  logo: "/logo.png",
  homeTitle: "Ti va di raccontare la tua esperienza?",
  homeSubtitle: "Bastano pochi secondi. La tua opinione per noi conta molto.",
  restaurantName: "Spazio Marconi · Pizza Bruna e Cucina",
};
